import React from 'react';
import { Facebook, Globe } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface DisplayConnectLinksProps {
  facebook?: string | null;
  website?: string | null;
  className?: string;
}

const DisplayConnectLinks: React.FC<DisplayConnectLinksProps> = ({
  facebook,
  website,
  className
}) => {
  if (!facebook && !website) return null;

  return (
    <div className={`space-y-2 ${className}`}>
      {facebook && (
        <a 
          href={facebook} 
          target="_blank" 
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button 
            variant="outline" 
            className="w-full justify-start text-sm"
            size="sm"
          >
            <Facebook className="h-4 w-4 mr-2" />
            Facebook
          </Button>
        </a>
      )}
      
      {website && (
        <a 
          href={website} 
          target="_blank" 
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button 
            variant="outline" 
            className="w-full justify-start text-sm"
            size="sm"
          >
            <Globe className="h-4 w-4 mr-2" />
            Website
          </Button>
        </a>
      )}
    </div>
  );
};

export default DisplayConnectLinks; 